import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class PolarConfig extends CloudObject {
    static DEFAULT_INSTANCE_TAG = '018d9e07c79eed61efe4'


    /**
     *
     * @param prop
     * @returns {unknown}
     */
    getPropIfExists(prop) {
        return this.get(prop) ?? CloudObject.get(PolarConfig.DEFAULT_INSTANCE_TAG).get(prop);
    }

    /**
     * @return {string}
     */
    getName() {
        return this.getPropIfExists(PolarConfig.nameProp);
    }

    /**
     * @return {string}
     */
    getKeyPath() {
        return this.getPropIfExists(PolarConfig.keyPathProp);
    }

    /**
     * @return {string}
     */
    getValuePath() {
        return this.getPropIfExists(PolarConfig.valuePathProp);
    }

    /**
     * @return {string}
     */
    getColorScale() {
        return this.getPropIfExists(PolarConfig.colorScaleProp);
    }

    /**
     * @return {string}
     */
    getColorPath() {
        return this.getPropIfExists(PolarConfig.colorPathProp);
    }

    /**
     * @return {string}
     */
    getConfigJSON() {
        return this.getPropIfExists(PolarConfig.configJSONProp);
    }

    /**
     * @return {string}
     */
    getLegend() {
        return this.getPropIfExists(PolarConfig.legendProp);
    }

    /**
     * @return {number}
     */
    getOrder() {
        return this.getPropIfExists(PolarConfig.orderProp);
    }

    /**
     * @return {string}
     */
    getType() {
        return this.getPropIfExists(PolarConfig.typeProp);
    }

    /**
     * @return {string}
     */
    getDataLabels() {
        return this.getPropIfExists(PolarConfig.dataLabelsProp);
    }
}

// Hardcoded tags
register('018d9cfba982c382bd4a', PolarConfig);
PolarConfig.nameProp = defineProperty('018d9cfbf1ebb6803a14');
PolarConfig.keyPathProp = defineProperty('018d9e107b08954fe3b9');
PolarConfig.valuePathProp = defineProperty('018d9e108e530e91e55d');
PolarConfig.colorPathProp = defineProperty('018d9cfc2b3c5baf0468');
PolarConfig.configJSONProp = defineProperty('018d9cfc3c26cc61bb72');
PolarConfig.legendProp = defineProperty('018d9cfcee0db5c3cb29');
PolarConfig.orderProp = defineProperty('018d9cfd104405d198b4');
PolarConfig.colorScaleProp = defineProperty('018da235fe9ab837e7bd');
PolarConfig.typeProp = defineProperty('018d9e0366e091094538');
PolarConfig.dataLabelsProp = defineProperty('018da37f91465c005e4a');
